import React from 'react'

import { Row, Col, Divider, Form, Table } from '_zari/core'

import * as GuiasVentaService from 'services/guiasVenta.service'

const ResumenGuias = ({ id, anio }) => {
  const [detallesData, setDetallesData] = React.useState({
    nroDoc: null,
    serieDoc: '',
    fechaEmision: '',
    fechaInicio: '',
    motivo: '',
    modalidad: '',
    razSoc: '',
    docIden: '',
    direcPrtd: '',
    direcLLeg: '',
    placas: [{ _id: '', placa: '' }],
    conductores: [
      {
        nroIden: '',
        tipoIden: ''
      }
    ],
    productos: [{ codigo: '', nombre: '', unidadMedida: '', cantidad: null }],
    pesoBruto: null
  })

  React.useEffect(() => {
    GuiasVentaService.verDetallesConsultaGuias(id, anio).then(({ data }) => {
      setDetallesData(data)
    })
  }, [id, anio])

  return (
    <>
      <Divider title='DATOS DEL DOCUMENTO' noMargin />
      <Row>
        <Col className='text-left' md={7}>
          <Form.Group>
            <Form.Label text='Serie documento :' noPadding md={3} alignRightAt='md' />
            <Col md={9}>
              <Form.OnlyText text={detallesData.serieDoc} noPadding />
            </Col>
          </Form.Group>
        </Col>
        <Col className='text-left' md={5} />
      </Row>
      <Row className='mb-5'>
        <Col className='text-left' md={7}>
          <Form.Group>
            <Form.Label text='Número Documento :' noPadding md={3} alignRightAt='md' />
            <Col md={9}>
              <Form.OnlyText text={detallesData.nroDoc} noPadding />
            </Col>
          </Form.Group>
        </Col>
        <Col className='text-left' md={5} />
      </Row>
      <Divider title='DATOS DEL TRASLADO' noMargin />
      <Row>
        <Col className='text-left' md={7}>
          <Form.Group>
            <Form.Label text='Fecha de Emision :' noPadding md={3} alignRightAt='md' />
            <Col md={9}>
              <Form.OnlyText text={detallesData.fechaEmision} noPadding />
            </Col>
          </Form.Group>
        </Col>
        <Col className='text-left' md={5} />
      </Row>
      <Row>
        <Col className='text-left' md={7}>
          <Form.Group>
            <Form.Label text='Fecha de inicio de traslado :' noPadding md={3} alignRightAt='md' />
            <Col md={9}>
              <Form.OnlyText text={detallesData.fechaInicio} noPadding />
            </Col>
            <Form.Label />
          </Form.Group>
        </Col>
        <Col className='text-left' md={5} />
      </Row>
      <Row>
        <Col className='text-left' md={7}>
          <Form.Group>
            <Form.Label text='Motivo de Traslado :' noPadding md={3} alignRightAt='md' />
            <Col md={9}>
              <Form.OnlyText text={detallesData.motivo} noPadding />
            </Col>
            <Form.Label />
          </Form.Group>
        </Col>
        <Col className='text-left' md={5} />
      </Row>
      <Row>
        <Col className='text-left' md={7}>
          <Form.Group>
            <Form.Label text='Modalidad de Transporte :' noPadding md={3} alignRightAt='md' />
            <Col md={9}>
              <Form.OnlyText text={detallesData.modalidad} noPadding />
            </Col>
            <Form.Label />
          </Form.Group>
        </Col>
        <Col className='text-left' md={5} />
      </Row>
      <Row className='mb-5'>
        <Col className='text-left' md={7}>
          <Form.Group>
            <Form.Label text='Peso Bruto total de la Guía :' noPadding md={3} alignRightAt='md' />
            <Col md={9}>
              <Form.OnlyText text={detallesData.pesoBruto} noPadding />
            </Col>
            <Form.Label />
          </Form.Group>
        </Col>
        <Col className='text-left' md={5} />
      </Row>
      <Divider title='DATOS DEL DESTINATARIO' noMargin />
      <Row>
        <Col className='text-left' md={7}>
          <Form.Group>
            <Form.Label text='Apellidos, Nombres o Razon Social :' noPadding md={3} alignRightAt='md' />
            <Col md={9}>
              <Form.OnlyText text={detallesData.razSoc} noPadding />
            </Col>
            <Form.Label />
          </Form.Group>
        </Col>
        <Col className='text-left' md={5} />
      </Row>
      <Row className='mb-5'>
        <Col className='text-left' md={7}>
          <Form.Group>
            <Form.Label text='Documento de Identidad :' noPadding md={3} alignRightAt='md' />
            <Col md={9}>
              <Form.OnlyText text={detallesData.docIden} noPadding />
            </Col>
            <Form.Label />
          </Form.Group>
        </Col>
        <Col className='text-left' md={5} />
      </Row>
      <Divider title='DATOS DEL PUNTO DE PARTIDA Y PUNTO DE LLEGADA' noMargin />
      <Row>
        <Col className='text-left' md={7}>
          <Form.Group>
            <Form.Label text='Direccion punto de partida :' noPadding md={3} alignRightAt='md' />
            <Col md={9}>
              <Form.OnlyText text={detallesData.direcPrtd} noPadding />
            </Col>
            <Form.Label />
          </Form.Group>
        </Col>
        <Col className='text-left' md={5} />
      </Row>
      <Row className='mb-5'>
        <Col className='text-left' md={7}>
          <Form.Group>
            <Form.Label text='Direccion punto de llegada :' noPadding md={3} alignRightAt='md' />
            <Col md={9}>
              <Form.OnlyText text={detallesData.direcLLeg} noPadding />
            </Col>
            <Form.Label />
          </Form.Group>
        </Col>
        <Col className='text-left' md={5} />
      </Row>
      <Divider title='DATOS DEL TRANSPORTE' noMargin />
      <Row className='mt-5'>
        <Col className='text-center' md={12}>
          <p>Datos de los vehículos</p>
          <Table
            maxRowsShown={5}
            filas={detallesData.placas ? [detallesData.placas] : []}
            headRows={[{ label: 'Nro.' }, { label: 'Placa' }]}
            rowTemplate={(row, k) => (
              <Table.Row key={k}>
                <Table.Cell className='text-center'>{1}</Table.Cell>
                <Table.Cell className='text-center'>{row.placa || '--'}</Table.Cell>
              </Table.Row>
            )}
          />
        </Col>
      </Row>
      <Row className='mt-5'>
        <Col className='text-center' md={12}>
          <p>Datos de los conductores</p>
          <Table
            maxRowsShown={5}
            filas={detallesData.conductores ? [detallesData.conductores] : []}
            headRows={[{ label: 'Nro.' }, { label: 'Tipo Documento' }, { label: 'Nro Documento' }]}
            rowTemplate={(row, k) => (
              <Table.Row key={k}>
                <Table.Cell className='text-center'>{1}</Table.Cell>
                <Table.Cell className='text-center'>{row.tipoIden || '--'}</Table.Cell>
                <Table.Cell className='text-center'>{row.nroIden || '--'}</Table.Cell>
              </Table.Row>
            )}
          />
        </Col>
      </Row>
      <Row className='mt-5'>
        <Col className='text-center' md={12}>
          <p>Datos de los bienes</p>
          <Table
            maxRowsShown={5}
            filas={detallesData.productos || []}
            headRows={[{ label: 'Nro.' }, { label: 'Cod. Bien' }, { label: 'Descripcion' }, { label: 'Unidad Medida' }, { label: 'Cantidad' }]}
            rowTemplate={(row, k) => (
              <Table.Row key={k}>
                <Table.Cell className='text-center'>{1}</Table.Cell>
                <Table.Cell className='text-center'>{row.codigo || '--'}</Table.Cell>
                <Table.Cell className='text-center'>{row.nombre || '--'}</Table.Cell>
                <Table.Cell className='text-center'>{row.unidadMedida || '--'}</Table.Cell>
                <Table.Cell className='text-center'>{row.cantidad || '--'}</Table.Cell>
              </Table.Row>
            )}
          />
        </Col>
      </Row>
    </>
  )
}

export default React.memo(ResumenGuias)
